import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import getLocation from "../services/location";
import { StoreList } from "../components/lists/StoreList";
import { useLocation } from "react-router-dom";
import PromoItemList from "../components/lists/PromoItemList";
import Loading from "../components/Loading";
import { Alert } from "@mui/material";

import { inProduct } from "../services/actions";
import { useDispatch } from "react-redux";
import { setError } from "../services/actions";

import { test_ip } from "../services/constants";
import { useCallback } from "react";

function SingleStore(props) {
  const [lat, setLat] = useState(null);
  const [lon, setLon] = useState(null);
  // const [error, setError] = useState(null)
  const [loading, setLoading] = useState(true);

  // const [items, setItems] = useState([]);
  const city_id = localStorage.getItem("city_id");

  // const [productList, setProductList] = useState([])
  const [products, setProducts] = useState([]);
  const [filter, setFilter] = useState([]);
  const dispatch = useDispatch();

  const nav = useNavigate();

  const location = useLocation();
  console.log("this location", location);
  console.log(location.state);
  const store = location.state.store;
  const delivery_id = location.state.delivery_id;
  // console.log(productList)

  useEffect(() => {
    getLocation((data) => {
      setLat(data.lat);
      setLon(data.lon);
    });
    dispatch(inProduct());
  }, []);
  useEffect(() => {
    var data = { store_id: store._id };
    console.log("in single store");
    Get_Product_list(data);
  }, [lat, lon]);
  const searchProducts = useCallback(
    (event) => {
      console.log(event.target.value);
      var fil = event.target.value;
      fil = fil.toLowerCase();
      setFilter(
        products.filter((store) => {
          return store.name.toLowerCase().includes(fil);
        })
      );
    },
    [products]
  );

  var Get_Product_list = function (data) {
    // call this only if store_count == 1
    var body = { store_id: data.store_id };
    body = JSON.stringify(body);
    axios
      .post(`${test_ip}api/user/user_get_store_product_item_list`, body, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        if (res.status === 200) {
          console.log(res);
          if (res.data.success == true) {
            var products = res.data.products; // all products of the store
            var new_list = [];
            products.forEach((element) => {
              element.items.forEach((element) => {
                new_list.push(element);
              });
            });
            console.log("hii products", new_list);
            setProducts(new_list);
            setFilter(new_list);
            setLoading(false);
          } else {
            console.log(res.data.error_code);
            // setError('error occured')
            dispatch(
              setError({
                error: true,
                message: "Failed to laod products, please reload",
              })
            );
          }
        } else {
          // do something
          // setError('error occured')
          dispatch(
            setError({
              error: true,
              message: "Failed to laod products, please reload",
            })
          );
        }
      })
      .catch((err) => {
        // do something
        // setError('error occured')
        dispatch(
          setError({
            error: true,
            message: "Failed to laod products, please reload",
          })
        );
      });
  };
  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        {" "}
        <Loading></Loading>
      </div>
    );
  } else {
    return (
      <div
        style={{
          backgroundColor: "white",
          width: "100vw",
          height: "100vh",
        }}
      >
        <div
          style={{
            backgroundColor: "white",
            marginTop: "5px",
            marginBottom: "5px",
            padding: "8px",
            fontSize: "0.8rem",
          }}
        >
          <h3 style={{ fontSize: "1.2rem" }}>{location.state.name}</h3>
          <div style={{ fontSize: "0.6rem" }}>
            displaying {products.length} products for you
          </div>
          <input
            type="text"
            style={{
              padding: "5px",
              marginTop: "5px",
              fontSize: "0.6rem",
              width: "50%",
            }}
            placeholder="Type a product name"
            onChange={searchProducts}
          />
        </div>
        <div style={{ background: "white" }}>
          <PromoItemList promo={filter} handleCart={props.handleCart} />
        </div>
      </div>
    );
  }
}

export default SingleStore;
